// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"customizedItemsCard_itemContainer__3B6wZ","itemList":"customizedItemsCard_itemList__3nkra"};